export enum AppViews {
  BasePath = "",
  Issues = "issues",
  Types = "types",
  CustomFields = "custom-fields",
  Permissions = "permissions",
  RootCauses = "root-causes",
  Templates = "templates",
  Statuses = "statuses",
  DeletedIssues = "deleted-issues",
}

export const getAppName = (): "build" | "docs" => {
  const match = window.location.pathname.match(/\/(.*)\/(.*)\/projects/);

  return match && ["build", "docs"].includes(match[1])
    ? (match[1] as "build" | "docs")
    : "docs";
};

export const getBasePath = (projectId: string | undefined) => {
  // @TODO: we should not allow a base path that doesn't have a project ID,
  // but that will take a bit of refactoring elsewhere
  if (!projectId) {
    return "";
  }
  return `/${getAppName()}/issues/projects/${projectId}`;
};
